import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProvisioningFormType } from '../../integration-apps.types';

@Component({
  selector: 'app-integration-apps-instance-provisioning-type-card',
  templateUrl: './integration-apps-instance-provisioning-type-card.component.html',
  standalone: false
})
export class IntegrationAppsInstanceProvisioningTypeCardComponent {

  @Input() entryType: ProvisioningFormType = 'label';

  @Output() onTypeSelected = new EventEmitter<ProvisioningFormType>();

  onCardClicked(entryType: ProvisioningFormType) {
    this.onTypeSelected.emit(entryType);
  }

}
